"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcNetSpeed = void 0;
var _method = _interopRequireDefault(require("../../../utils/method"));
/**
 * @function calculateNetSpeed
 * @description 计算网速
 * @param {function} cb 回调函数(发送数据)
 * @private
 */

var Methods = new _method.default();
var TIME_OUT = 4500;
var NET_SPEED_IMG_BIG = 'https://pic2.zhuanstatic.com/zhuanzh/e64c9fed-6dee-4cb9-9bbb-bbbef7ec25a8.png';
var NET_SPEED_IMG_SMALL = 'https://pic5.zhuanstatic.com/zhuanzh/8a208a4e-9d33-4c22-b6d9-b0db1574c7e6.png';
var NET_SPEED_IMG_SIZE = 5;
var calcNetSpeed = exports.calcNetSpeed = function calcNetSpeed() {
  return new Promise(function (resolve) {
    var res = {
      type: 'netSpeed',
      value: '30003'
    };
    // 超时兜底, 图片加载出错超时,  速度可以认为小于2.5k/s
    var timer = setTimeout(function () {
      clearTimeout(timer);
      timer = null;
      res.value = '30004';
      resolve(res);
    }, TIME_OUT);
    try {
      var performance = window.performance;
      var smallImgData = window['netSpeedSmallImg'] || (window['netSpeedSmallImg'] = {});
      var imgData = window['netSpeedImg'] || (window['netSpeedImg'] = {});
      var _unique = Methods.getUnique();
      var smallImg = smallImgData[_unique] = new Image();
      var img = imgData[_unique] = new Image();
      var start = 0;
      smallImg.onload = smallImg.onerror = function () {
        smallImg.onload = smallImg.onerror = null;
        smallImg = smallImgData[_unique] = null;
        // 小图片加载完 打点 start
        start = performance.now ? performance.now() : +new Date();
        // 再加载一张大图，用于计算加载大图加载时间差
        img.src = NET_SPEED_IMG_BIG + '?_unique=' + _unique;
      };
      // 先加载一张小图，小图加载完后 再加载一张大图 用于计算，减少资源排队的影响
      smallImg.src = NET_SPEED_IMG_SMALL + '?_unique=' + _unique;
      img.onload = img.onerror = function () {
        img.onload = img.onerror = null;
        img = imgData[_unique] = null;
        // 大图片加载完 打点 end, 计算加载大图加载时间差
        var time = performance.now ? performance.now() - start : +new Date() - start;
        var netTime = parseInt(time.toString(), 10) || 0;
        var netSpeed = (NET_SPEED_IMG_SIZE * 1000 / netTime).toFixed(2);
        res.value = netSpeed;
        resolve(res);
      };
    } catch (err) {
      // console.error(err)
      // 图片加载出错 30003
      resolve(res);
    }
  });
};